import type { IconData } from '@stacksjs/iconify-core'

export const chevronUpLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 2v7a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronUpLeft
